export enum KeyPairingState {
    PAIRED = 'PAIRED',
    PENDING = 'PENDING',
    NOT_POSSIBLE = 'NOT_POSSIBLE',
}
